import { render, staticRenderFns } from "./AltaCp.vue?vue&type=template&id=7d1b326f"
import script from "./AltaCp.vue?vue&type=script&lang=js"
export * from "./AltaCp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports